import React from 'react';

function SponsorLogo({ sponsorLogo }) {
    return (
        <div className="single-brand-logo">
            <img src={sponsorLogo} alt="" />
        </div>
    );
}

export default SponsorLogo;
